import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getLandingpagePath } from '../../routes/config';
import Image from '../../utils/Image';
import Toggle from '../../utils/Toggle';
import I18n from '../../config/i18n';

import './landingpage-teaser.css';

interface TeaserLinkProps {
  slug: string;
  children: React.ReactNode;
}

const externalLandingPages = ['ardennen', 'wellnesssuites', 'ibiza', 'mallorca', 'cotedazur'];

function TeaserLink({ slug, children }: TeaserLinkProps): JSX.Element {
  if (slug === 'austria') {
    return (
      <a
        href={I18n.t('footer.vouchers_link')}
        target="_blank"
        rel="noopener noreferrer"
        className="landingpage-teaser"
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      to={getLandingpagePath(slug)}
      reloadDocument={externalLandingPages.includes(slug)}
      className="landingpage-teaser"
    >
      {children}
    </Link>
  );
}

interface LandingpageTeaserProps {
  teaserImage: string;
  title: string;
  description: string;
  bigTeaser?: boolean;
  slug: string;
}

export default function LandingpageTeaser({
  teaserImage,
  title,
  description,
  bigTeaser,
  slug,
}: LandingpageTeaserProps): JSX.Element {
  return (
    <TeaserLink slug={slug}>
      <Image src={teaserImage} className="landingpage-teaser-image" />
      <div className="landingpage-teaser-content">
        <h3 className="landingpage-teaser-title">
          {slug === 'austria' ? I18n.t('landing_page_teaser.title') : title}
        </h3>
        {bigTeaser ? (
          <Toggle hide="xs sm">
            <div
              className="landingpage-teaser-text"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Toggle>
        ) : null}
      </div>
    </TeaserLink>
  );
}

const defaultProps: Pick<LandingpageTeaserProps, 'bigTeaser'> = {
  bigTeaser: false,
};

LandingpageTeaser.defaultProps = defaultProps;
